import { getRelativeDate } from '../utils/dateHelpers';

export const calendarEvents = [
  // Current Week Events
  {
    id: 1,
    title: "City Council Meeting",
    date: getRelativeDate(0),
    time: "6:00 PM",
    location: "City Hall Council Chambers",
    category: "Government",
    description: "Regular city council meeting open to the public",
    recurring: "Every 1st and 3rd Wednesday"
  },
  {
    id: 2,
    title: "Roseville Winter Farmers Market",
    date: getRelativeDate(2),
    time: "8:00 AM - 1:00 PM",
    location: "Downtown Roseville Plaza",
    category: "Community",
    description: "Weekly farmers market featuring local produce and artisan goods",
    recurring: "Every Saturday"
  },
  {
    id: 3,
    title: "Live Music at The Monk's Cellar",
    date: getRelativeDate(3),
    time: "7:00 PM",
    location: "The Monk's Cellar",
    category: "Music",
    description: "Acoustic performances by local artists"
  },
  {
    id: 4,
    title: "Toddler Story Time",
    date: getRelativeDate(4),
    time: "10:00 AM",
    location: "Roseville Public Library",
    category: "Family",
    description: "Interactive story time for children ages 2-5",
    recurring: "Every Monday and Wednesday"
  },
  {
    id: 5,
    title: "Business Networking Breakfast",
    date: getRelativeDate(5),
    time: "7:30 AM",
    location: "Roseville Chamber of Commerce",
    category: "Business",
    description: "Monthly networking event for local business professionals"
  },
  {
    id: 6,
    title: "Yoga in the Park",
    date: getRelativeDate(6),
    time: "6:30 PM",
    location: "Maidu Park",
    category: "Health",
    description: "Free outdoor yoga class for all skill levels",
    recurring: "Every Tuesday and Thursday"
  },
  {
    id: 7,
    title: "Family Movie Night",
    date: getRelativeDate(7),
    time: "6:30 PM",
    location: "Mahany Park",
    category: "Family",
    description: "Outdoor movie screening under the stars"
  },
  
  // Next Week Events
  {
    id: 8,
    title: "Roseville Art Walk",
    date: getRelativeDate(8),
    time: "5:00 PM - 9:00 PM",
    location: "Historic Downtown",
    category: "Arts",
    description: "Monthly art walk featuring local galleries and artists"
  },
  {
    id: 9,
    title: "Planning Commission Meeting",
    date: getRelativeDate(10),
    time: "6:00 PM",
    location: "City Hall",
    category: "Government",
    description: "Public meeting to discuss development projects"
  },
  {
    id: 10,
    title: "City Council Meeting",
    date: getRelativeDate(12),
    time: "6:00 PM",
    location: "City Hall Council Chambers",
    category: "Government",
    description: "Regular city council meeting open to the public",
    recurring: "Every 1st and 3rd Wednesday"
  },
  {
    id: 11,
    title: "5K Fun Run for Charity",
    date: getRelativeDate(14),
    time: "8:00 AM",
    location: "Johnson-Springview Park",
    category: "Sports",
    description: "Community fun run benefiting local schools"
  },
  {
    id: 12,
    title: "Youth Basketball Tournament",
    date: getRelativeDate(15),
    time: "9:00 AM - 5:00 PM",
    location: "Roseville Sports Center",
    category: "Sports",
    description: "Annual youth basketball championship"
  },
  {
    id: 13,
    title: "Cooking Class: Italian Cuisine",
    date: getRelativeDate(19),
    time: "6:00 PM",
    location: "Culinary Arts Studio",
    category: "Food",
    description: "Hands-on cooking class with Chef Marco"
  },
  {
    id: 14,
    title: "Roseville Spring Festival",
    date: getRelativeDate(22),
    time: "10:00 AM - 6:00 PM",
    location: "Mahany Park",
    category: "Festival",
    description: "Three-day spring celebration with music, food, and activities"
  },
  {
    id: 15,
    title: "Roseville Spring Festival - Day 2",
    date: getRelativeDate(23),
    time: "10:00 AM - 6:00 PM",
    location: "Mahany Park",
    category: "Festival",
    description: "Spring festival continues with live entertainment"
  },
  {
    id: 16,
    title: "Roseville Spring Festival - Day 3",
    date: getRelativeDate(24),
    time: "10:00 AM - 6:00 PM",
    location: "Mahany Park",
    category: "Festival",
    description: "Final day of spring festival celebration"
  },
  {
    id: 17,
    title: "City Council Meeting",
    date: getRelativeDate(26),
    time: "6:00 PM",
    location: "City Hall Council Chambers",
    category: "Government",
    description: "Regular city council meeting open to the public",
    recurring: "Every 1st and 3rd Wednesday"
  },
  {
    id: 18,
    title: "Senior Center Dance",
    date: getRelativeDate(28),
    time: "2:00 PM",
    location: "Roseville Senior Center",
    category: "Community",
    description: "Monthly social dance for seniors"
  },
  {
    id: 19,
    title: "Earth Day Cleanup",
    date: getRelativeDate(29),
    time: "9:00 AM",
    location: "Various Parks",
    category: "Community",
    description: "Volunteer cleanup event for local parks"
  },
  {
    id: 20,
    title: "Jazz Night at Blue Line Arts",
    date: getRelativeDate(32),
    time: "7:30 PM",
    location: "Blue Line Arts Gallery",
    category: "Music",
    description: "Live jazz performance and art exhibition"
  },
  {
    id: 21,
    title: "Small Business Workshop",
    date: getRelativeDate(34),
    time: "6:00 PM",
    location: "Chamber of Commerce",
    category: "Business",
    description: "Workshop on digital marketing for small businesses"
  },
  {
    id: 22,
    title: "Kids' Science Fair",
    date: getRelativeDate(36),
    time: "10:00 AM - 3:00 PM",
    location: "Roseville Community Center",
    category: "Education",
    description: "Annual science fair showcasing student projects"
  },
  
  // Future Events
  {
    id: 23,
    title: "City Council Meeting",
    date: getRelativeDate(40),
    time: "6:00 PM",
    location: "City Hall Council Chambers",
    category: "Government",
    description: "Regular city council meeting open to the public",
    recurring: "Every 1st and 3rd Wednesday"
  },
  {
    id: 24,
    title: "Spring Garden Tour",
    date: getRelativeDate(43),
    time: "10:00 AM - 4:00 PM",
    location: "Various Locations",
    category: "Community",
    description: "Self-guided tour of beautiful local gardens"
  },
  {
    id: 25,
    title: "Concert in the Park",
    date: getRelativeDate(50),
    time: "6:00 PM",
    location: "Mahany Park",
    category: "Music",
    description: "Free outdoor concert series begins"
  },
  {
    id: 26,
    title: "City Council Meeting",
    date: getRelativeDate(54),
    time: "6:00 PM",
    location: "City Hall Council Chambers",
    category: "Government",
    description: "Regular city council meeting open to the public",
    recurring: "Every 1st and 3rd Wednesday"
  },
  {
    id: 27,
    title: "Earth Day Festival",
    date: getRelativeDate(60),
    time: "11:00 AM - 5:00 PM",
    location: "Maidu Park",
    category: "Community",
    description: "Celebrate Earth Day with eco-friendly activities and vendors"
  },
  {
    id: 28,
    title: "Food Truck Friday",
    date: getRelativeDate(63),
    time: "5:00 PM - 9:00 PM",
    location: "Downtown Roseville",
    category: "Food",
    description: "Monthly food truck gathering with live music",
    recurring: "Last Friday of every month"
  }
];

export const eventCategories = [
  "All Events",
  "Community",
  "Music",
  "Arts",
  "Sports",
  "Family",
  "Food",
  "Business",
  "Government",
  "Health",
  "Education",
  "Festival"
];

export const calendarCategories = [
  { value: "all", label: "All Events", icon: "ri-calendar-line" },
  { value: "community", label: "Community", icon: "ri-community-line" },
  { value: "music", label: "Music", icon: "ri-music-line" },
  { value: "arts", label: "Arts", icon: "ri-palette-line" },
  { value: "sports", label: "Sports", icon: "ri-basketball-line" },
  { value: "family", label: "Family", icon: "ri-parent-line" },
  { value: "food", label: "Food", icon: "ri-restaurant-line" },
  { value: "business", label: "Business", icon: "ri-briefcase-line" },
  { value: "government", label: "Government", icon: "ri-government-line" },
  { value: "health", label: "Health", icon: "ri-heart-pulse-line" },
  { value: "education", label: "Education", icon: "ri-book-line" },
  { value: "festival", label: "Festival", icon: "ri-flag-line" }
];
